
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Newsletter'
})
export default class Newsletter extends Vue {}
